export const FeedbackTypesEnum = {
    Accepted: "accepted",
    MaxRetries: "maxRetries",
    InCorrect: "inCorrect",
    Correct: "correct"
}